import { IconButton } from "@dropbox/dig-components/buttons";
import { Text, Title } from "@dropbox/dig-components/typography";
import { UIIcon } from "@dropbox/dig-icons";
import {
  CloseLine,
  SettingsLine,
  WarningLine,
} from "@dropbox/dig-icons/assets";
import styles from "./PanelHeader.module.css";

interface PanelHeaderProps {
  title: string;
  latency?: number;
  hasConfig: boolean;
  onToggleConfig: () => void;
  onRemove?: () => void;
  hasMagicFlags?: boolean;
  searchRequestId?: string;
}

export const PanelHeader = ({
  title,
  latency,
  searchRequestId,
  hasConfig,
  onToggleConfig,
  onRemove,
  hasMagicFlags = false,
}: PanelHeaderProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.panelHeaderContent}>
        <Title className={styles.title} size="small">
          {title}
        </Title>
        <div className={styles.headerButtons}>
          {hasConfig && (
            <div className={styles.settingsContainer}>
              {hasMagicFlags && (
                <button
                  className={styles.magicFlagWarningContainer}
                  onClick={onToggleConfig}
                  type="button"
                >
                  <UIIcon
                    src={WarningLine}
                    className={styles.magicFlagWarning}
                  />
                  <Text size="xsmall" color="subtle">
                    Magic flags enabled for this panel
                  </Text>
                </button>
              )}
              <IconButton
                onClick={onToggleConfig}
                variant="transparent"
                size="medium"
              >
                <UIIcon src={SettingsLine} />
              </IconButton>
            </div>
          )}
          {onRemove && (
            <IconButton variant="transparent" size="medium" onClick={onRemove}>
              <UIIcon src={CloseLine} />
            </IconButton>
          )}
        </div>
      </div>
      <div className={styles.requestMetadata}>
        {latency !== undefined && (
          <Text size="xsmall" color="subtle">
            Latency: {latency}ms
          </Text>
        )}
        {searchRequestId && (
          <Text size="xsmall" color="subtle">
            Search Request ID: {searchRequestId}
          </Text>
        )}
      </div>
    </div>
  );
};
